import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomizerSettingsService } from 'src/app/components/customizer-settings/customizer-settings.service';
import { getMailSidebar, MailSidebar } from 'src/app/core/constants/mail-box-const';
import { permissionEntity } from 'src/app/core/constants/permission';
import { urlRoutes } from 'src/app/core/constants/url-route.constant';
import { LocalStorageService } from 'src/app/core/services/localStorage/localStorage.service';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { ComposeMailPopupComponent } from 'src/app/core/shared-modules/components/compose-mail-popup/compose-mail-popup.component';

@Component({
  selector: 'app-mail-sidebar',
  templateUrl: './mail-sidebar.component.html',
  styleUrls: ['./mail-sidebar.component.scss']
})
export class MailSidebarComponent implements OnInit, OnChanges {
  mail_sidebar = getMailSidebar(this._localStorageService);
  @Input() dashboard_counts: any;
  @Output() trigger_menu_change: EventEmitter<any> = new EventEmitter();
  public routerUrl = urlRoutes;
  selected_menu: any;
  permissions_entity = permissionEntity;
  
  constructor(
    public themeService: CustomizerSettingsService,
    private _navigationService: NavigationService,
    public dialog: MatDialog,
    private _localStorageService: LocalStorageService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['dashboard_counts']?.currentValue) {
      this.dashboard_counts = changes['dashboard_counts']?.currentValue;
      if (this.dashboard_counts) {
        this.mail_sidebar.forEach(element => {
          if (this.dashboard_counts[element.count_label]) {
            element.count = this.dashboard_counts[element.count_label];
          }
        })
      }
    }
  }

  ngOnInit(): void {
    this.selected_menu = this.mail_sidebar[0];
  }

  loadMail(menu: any) {
    this.selected_menu = menu;
    this.trigger_menu_change.emit(menu);
  }

  navigateTo(path: string) {
    let url = `${urlRoutes.mainLayout}/${urlRoutes.university_communications}/${urlRoutes.mail_box}/${path}`;
    this._navigationService.routeToPath(url)
  }

  toggleRTLEnabledTheme() {
    this.themeService.toggleRTLEnabledTheme();
  }

  public composeMail(): void {
    const dialogRef = this.dialog.open(ComposeMailPopupComponent, {
        width: '100%',
        height:'auto',
        maxHeight:'95vh',
        enterAnimationDuration: '300ms',
        exitAnimationDuration: '100ms',
        data: {},
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
       
      }
    });
  }
}
